<div class="section" *ngIf="teamUniform?.file?.path || teamPhoto?.file?.path">
  <div class="title">Команда и форма</div>
  <div class="team-photos-b">
    <div *ngIf="teamUniform && teamUniform.file.path" class="team-uniform" [ngClass]="{full: !teamPhoto || !teamPhoto.file.path}">
      <img [src]="teamUniform.file.path" />
    </div>
    <div *ngIf="teamPhoto && teamPhoto.file.path" class="team-photo" [ngClass]="{full: !teamUniform || !teamUniform.file.path}">
      <img [src]="teamPhoto.file.path" />
    </div>
  </div>
</div>
